import React, { ReactElement } from 'react';
import { getMaxFirstRegistrationDate } from '../../services/common/validation';
import {
  QuoteCalculateResponse,
  QuoteCalculationServicePlanResponseModel,
} from '../../services/redux/features/api/quoteCalculate.api-slice';
import { DatePickerFormField } from '../Fieldset/DatePickerFormField';
import { NumericInputFormField } from '../Fieldset/NumericInputFormField';
import { SelectFormField } from '../Fieldset/SelectFormField';
import { TextInputFormField } from '../Fieldset/TextInputFormField';
import { AdditionalServicePlanFormModel, AdditionalServicePlanFormModelFields } from './form.model';

const typeSafeFormFieldName = (formFieldName: keyof AdditionalServicePlanFormModel) => formFieldName;

export const createFormInputs = (() => {
  return {
    firstRegistrationDate: () => (
      <DatePickerFormField
        fieldName={typeSafeFormFieldName('firstRegistrationDate')}
        labelTranslationKey="additionalServicePlan:additionalServicePlanForm.firstRegistrationDate.label"
        placeholderTranslationKey="additionalServicePlan:additionalServicePlanForm.firstRegistrationDate.placeholder"
        testId={typeSafeFormFieldName('firstRegistrationDate')}
        maxDate={getMaxFirstRegistrationDate()}
      />
    ),
    recordedKilometers: () => (
      <NumericInputFormField
        fieldName={typeSafeFormFieldName('recordedKilometers')}
        labelTranslationKey="additionalServicePlan:additionalServicePlanForm.recordedKilometers.label"
        placeholderTranslationKey="additionalServicePlan:additionalServicePlanForm.recordedKilometers.placeholder"
        type="km"
      />
    ),
    servicePlanName: (servicePlanList) => (
      <SelectFormField
        fieldName={typeSafeFormFieldName('servicePlanName')}
        labelTranslationKey="additionalServicePlan:additionalServicePlanForm.servicePlanName.label"
        testId={typeSafeFormFieldName('servicePlanName')}
        optionList={servicePlanList}
      />
    ),
    paymentType: () => (
      <SelectFormField
        fieldName={typeSafeFormFieldName('paymentType')}
        labelTranslationKey="additionalServicePlan:additionalServicePlanForm.paymentType.label"
        optionList={[
          {
            label: 'Monthly',
            value: 'monthly',
          },
          {
            label: 'Upfront',
            value: 'upfront',
          },
        ]}
        testId={typeSafeFormFieldName('paymentType')}
      />
    ),
    contractDuration: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('contractDuration')}
        labelTranslationKey="additionalServicePlan:additionalServicePlanForm.contractDuration.label"
        testId={typeSafeFormFieldName('contractDuration')}
        isDisabled
      />
    ),
    paymentTerm: (paymentTermList) => (
      <SelectFormField
        fieldName={typeSafeFormFieldName('paymentTerm')}
        labelTranslationKey="additionalServicePlan:additionalServicePlanForm.paymentTerm.label"
        optionList={paymentTermList}
        testId={typeSafeFormFieldName('paymentTerm')}
      />
    ),
    payment: (data: QuoteCalculateResponse | QuoteCalculationServicePlanResponseModel | undefined) => (
      <NumericInputFormField
        fieldName={typeSafeFormFieldName('payment')}
        type="money"
        maximumFractionDigits={2}
        isReadonly
        isSuccess={data?.isQuoteValid}
        isError={data?.isQuoteValid === false}
      />
    ),
  };
}) satisfies () => Record<AdditionalServicePlanFormModelFields, (...args: any[]) => ReactElement>;
